import moment from 'moment'
import { Fragment } from 'react'
import './calendar.css'

const weekdayshort = moment.weekdaysShort()
const firstDayOfMonth = (date) => moment(date).startOf('month').format('d')
const daysInMonth = (date) => moment(date).daysInMonth()

function isToday(day, monthIndex, year) {
    let today = new Date()
    let todayDateOnly = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
    )
    let givenDate = new Date(year, monthIndex, day)

    return todayDateOnly.getTime() === givenDate.getTime()
}

export default function Month({ monthInfo }) {
    console.log('reached month')

    const { nameOfMonth, date, attendance } = monthInfo

    let totalDaysInMonth = daysInMonth(date)
    let firstDayOfThisMonth = firstDayOfMonth(date)
    let blank = []

    for (let day = 0; day < firstDayOfThisMonth; day++)
        blank.push(<p className="blank dayClass"></p>)

    let daysInMonthArray = []

    for (let d = 1; d <= totalDaysInMonth; d++) {
        let dayClassName = 'dayClass '
        if (isToday(d, date.getMonth(), date.getFullYear()))
            dayClassName += 'today '
        if (d in attendance)
            dayClassName += !!attendance[d] ? 'present' : 'absent'

        daysInMonthArray.push(
            <p className={dayClassName}>{d < 10 ? `0${d}` : d}</p>
        )
    }

    let totalSlots = [...blank, ...daysInMonthArray]

    return (
        <>
            <div className="month-container">
                <p className="month-name">{nameOfMonth}</p>
                <div className="weeks-container">
                    {weekdayshort.map((item, key) => (
                        <p className="day-name" key={key}>
                            {item[0]}
                        </p>
                    ))}
                </div>
                <div className="days-container">
                    {totalSlots.map((day, index) => (
                        <Fragment key={index}>{day}</Fragment>
                    ))}
                </div>
            </div>
            <div className="delimeter-calendar">
                <span />
                <span />
                <span />
            </div>
        </>
    )
}
